import { useEffect } from "react";
import {
  ZEN_BOOK_CSS,
  ZEN_BOOK_HTML,
  ZEN_BOOK_TITLE,
} from "../content/zen-book";

/**
 * ZenPage — "Zen and the Art of AI Maintenance", a book-length piece served
 * as its own page at /zen.
 *
 * Unlisted in the investors-page mold (CO 297-003): no nav entry, `noindex`,
 * shared by URL. Deliberately rendered outside the Layout shell — the book
 * carries its own complete typography (paper tones, book paragraphing) and
 * shouldn't wear the portal chrome. Dark mode keys off the same html.dark
 * class the rest of the portal uses.
 *
 * Content is generated from the canonical copy in comai-plan
 * (docs/marketing/content/books/) — see content/zen-book.ts; never edit the
 * HTML string by hand.
 */

/** Link-shared, not search-discovered. */
function useNoIndex() {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex";
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);
}

export function ZenPage() {
  useNoIndex();

  useEffect(() => {
    const previous = document.title;
    document.title = ZEN_BOOK_TITLE;
    return () => {
      document.title = previous;
    };
  }, []);

  return (
    <div className="zen-book">
      <style>{ZEN_BOOK_CSS}</style>
      {/* Static, repo-owned HTML — no user input anywhere in the string. */}
      <div dangerouslySetInnerHTML={{ __html: ZEN_BOOK_HTML }} />
    </div>
  );
}
